module.exports = ({
	registerTemplateModifier,
	isString,
	isNull
}) => {
	const classIfTrue = (obj, [className] = []) => obj === true && className || '';
	const classIfFalse = (obj, [className] = []) => obj === false && className || '';

	registerTemplateModifier('strToInt', (obj) => {
		return isString(obj) ? parseInt(obj) : 0;
	});

	registerTemplateModifier('isNull', (obj) => isNull(obj));
	registerTemplateModifier('isNotNull', (obj) => !isNull(obj));

	registerTemplateModifier('hideIfTrue', (obj) => classIfTrue(obj, ['_hidden']));
	registerTemplateModifier('hideIfFalse', (obj) => classIfFalse(obj, ['_hidden']));

	registerTemplateModifier('classIfTrue', classIfTrue);
	registerTemplateModifier('classIfFalse', classIfFalse);

	registerTemplateModifier('testString', (obj = '', params) => {
		return obj.match(params[0]) !== null;
	});
};


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/template-modifiers/index.es.js